import type { FC } from 'react';
import { alpha, Button, useTheme } from '@/shared/ui/mui';
import useAuth from '@/features/auth/hooks/useAuth';
import { logger } from '@/shared/utils/logger';

interface AuthButtonsProps {
  loginContext?: 'client' | 'provider';
}

export const AuthButtons: FC<AuthButtonsProps> = ({ loginContext }) => {
  const theme = useTheme();
  const { isAuthenticated, login } = useAuth();

  // Don't render auth buttons if user is already authenticated
  if (isAuthenticated) {
    return null;
  }

  const handleLogin = async () => {
    try {
      // Direct Auth0 login - PostLogin will handle routing based on user state
      await login(loginContext);
    } catch (error) {
      logger.error('Login failed:', error);
    }
  };

  return (
    <Button
      variant="contained"
      onClick={handleLogin}
      sx={{
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        fontWeight: 'bold',
        px: { xs: 1.5, sm: 2.5 },
        py: { xs: 0.5, sm: 0.75 },
        fontSize: { xs: '0.75rem', sm: '0.875rem' },
        minWidth: 'auto',
        boxShadow: `0 3px 10px ${alpha(theme.palette.primary.main, 0.6)}`,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
          boxShadow: `0 5px 12px ${alpha(theme.palette.primary.main, 0.5)}`,
        },
      }}
    >
      Login
    </Button>
  );
};
